import { Response } from './Types';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import Api from '../services/Api';

class ReajusteEstoqueController {
    static async Listar(request: any): Promise<Response> {
        try {
            const response = await Api.post('api/reajusteestoque/Listar', request);

            const object = response?.data;

            const retorno: Response = {
                StatusCode: response.status,
                Data: object,
                ErroDetalhado: undefined
            };

            return retorno;
        } catch (error: any) {
            const retorno: Response = {
                StatusCode: error?.response?.status,
                Data: ErrorDictionary(error?.response?.status),
                ErroDetalhado: undefined
            };
            return retorno;
        }
    }

    public static async Adicionar(request: any): Promise<Response> {
        try {
            console.log('Controller Reajuste Adicionar');
            console.log(request);

            const response = await Api.post(`api/reajusteestoque/Adicionar`, request);

            const object = response?.data;

            const retorno: Response = {
                StatusCode: response.status, Data: object,
                ErroDetalhado: undefined
            };
            return retorno;

        } catch (error: any) {
            const retorno: Response = {
                StatusCode: error?.response?.status,
                Data: ErrorDictionary(error?.response?.status),
                ErroDetalhado: undefined
            };
            return retorno;
        }
    }

    public static async Baixar(request: any): Promise<Response> {
        try {
            console.log('Controller Reajuste Baixar');
            console.log(request);

            const response = await Api.post(`api/reajusteestoque/Baixar`, request);

            const object = response?.data;

            const retorno: Response = {
                StatusCode: response.status, Data: object,
                ErroDetalhado: undefined
            };
            return retorno;

        } catch (error: any) {
            const retorno: Response = {
                StatusCode: error?.response?.status,
                Data: ErrorDictionary(error?.response?.status),
                ErroDetalhado: undefined
            };
            return retorno;
        }
    }
}

export default ReajusteEstoqueController;